import { render, staticRenderFns } from "./topicInfo.vue?vue&type=template&id=786d87f0&scoped=true"
import script from "./topicInfo.vue?vue&type=script&lang=js"
export * from "./topicInfo.vue?vue&type=script&lang=js"
import style0 from "./topicInfo.vue?vue&type=style&index=0&id=786d87f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d87f0",
  null
  
)

export default component.exports